import { Swiper, SwiperSlide } from "swiper/react";
import * as Icons from "lucide-react";
import { LucideProps } from "lucide-react";

import { Link, useNavigate } from "react-router-dom";
// @ts-ignore
import "swiper/css";
// @ts-ignore
import "swiper/css/navigation";
// @ts-ignore
import "swiper/css/pagination";
import Header from "../components/Header";
import { useQuery } from "@tanstack/react-query";
import { getEvents } from "../api/events.ts";
import { getCategories } from "../api/categories.ts";
import {
  JSXElementConstructor,
  Key,
  ReactElement,
  ReactNode,
  ReactPortal,
  useEffect,
  useState,
} from "react";
import EventsSkeleton from "../components/skeletons/EventsSkeleton.tsx";
import CategoriesSkeleton from "../components/skeletons/CategoriesSkeleton.tsx";
import EventCard from "../components/EventCard.tsx";
import useDataStore from "../store/dataStore.ts";
import NoEvents from "../components/NoEvents.tsx";

type Event = {
  event: {
    eventDate: string; // Ou Date si les dates sont déjà sous forme d'objet Date
  };
};

type IconKeys = keyof typeof Icons;

const filterEvents = (array: any) => {
  const priorityOrder = { "Elevé": 1, "Moyen": 2, "Faible": 3 };

  const sortedArray = array?.sort((a: { event: { isPriority: any; priorityLevel: string | number; }; }, b: { event: { isPriority: any; priorityLevel: string | number; }; }) => {
    // Trier par isPriority (true avant false)
    if (a?.event?.isPriority !== b?.event?.isPriority) {
      return a?.event?.isPriority ? -1 : 1;
    }

    // Si isPriority est le même, trier par priorityLevel
    // @ts-ignore
    return priorityOrder[a?.event?.priorityLevel] - priorityOrder[b?.event?.priorityLevel];
  });

  return sortedArray?.slice(0, 3);
}

function moveItemToEnd(array: any[], label: string) {
  return [
    ...array.filter((item) => item.label !== label), // Garde les éléments qui ne correspondent pas au label
    ...array.filter((item) => item.label === label), // Ajoute à la fin ceux qui correspondent au label
  ];
}

const App = () => {
  const navigate = useNavigate();
  const [filteredEvents, setFilteredEvents] = useState<Event[]>([]);

  const { data: events, isLoading: isLoadingEvents } = useQuery({
    queryKey: ["events"],
    queryFn: () => getEvents(),
    staleTime: 0,
  });

  const { data: categories, isLoading: isLoadingCategories } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getCategories(),
    staleTime: 0,
  });


  useEffect(() => {
    if (events && events?.length >= 0) {
      useDataStore.getState().setCurrentEvents(events);
      setFilteredEvents(filterEvents(events));
    } else  {
      useDataStore.getState().setCurrentEvents([]);
    }
  }, [events]);

  useEffect(() => {
    const currentEvents =useDataStore.getState().currentEvents;
    if (currentEvents?.length > 0) {
      setFilteredEvents(filterEvents(currentEvents));
    }
  }, [events]);

  const goToAllEvents = () => {
    navigate("/Events");
  };


  const renderEvents = () => {
    if(isLoadingEvents){
      return <EventsSkeleton/>
    }
    return (
        <div className="flex flex-col gap-4">
          {filteredEvents?.length > 0 ?
              filteredEvents?.map(
                  (item: { event: any }, index: Key | null | undefined) => {
                    const event = item?.event;
                    return (
                        <EventCard link={`/Event/${event?.reference}`} key={index} event={event}/>
                    );
                  }
              ) : (
                  <NoEvents/>
              )}
        </div>
    );
  }

  return (
      <div style={{
        backgroundImage: `url('/pattern-white.svg')`,
        backgroundSize: 'inherit',
        backgroundPosition: 'center',
        fontFamily: "Exo",
        backgroundRepeat: 'no-repeat'
      }} className="min-h-screen flex flex-col text-white bg-gray-100">

        {/* Contenu principal avec défilement */}
        <div
            className=" inset-0 overflow-y-auto z-10"
        >
          {/* Header */}
          <div className="p-4">
            <Header/>
          </div>

          {/* Section Bienvenue */}
          <section className="mx-4 my-2">
            <h1 className="text-xl text-black font-semibold">Bonjour,</h1>
            <p className="text-black">Explorons les prochains événements</p>

            {/* <Swiper spaceBetween={0} slidesPerView={6} className="mt-4">
              {[
                "10 Lun",
                "11 Mar",
                "12 Mer",
                "13 Jeu",
                "14 Ven",
                "15 Sam",
                "16 Dim",
              ].map((day, index) => (
                  <SwiperSlide key={index} className="w-8">
                    <div
                        className={`p-2 rounded-lg text-center w-12 h-16 py-2 ${
                            day.includes("12") ? "bg-white text-blue-900 font-bold" : ""
                        }`}
                    >
                      {day}
                    </div>
                  </SwiperSlide>
              ))}
            </Swiper> */}
          </section>

          {/* Catégories */}
          {import.meta.env.VITE_VMS_APP_DISPLAY_CATEGORY === 'true' && <section className="mt-4">
            <h2 className="text-black text-lg mb-2 mx-4">Tous les types d'événements</h2>
            {isLoadingCategories ? (
                <CategoriesSkeleton/>
            ) : (
                <Swiper spaceBetween={2} slidesPerView={3}>
                  {categories?.length > 0 &&
                      moveItemToEnd(categories, "AUTRES")?.map(
                          (
                              item: {
                                iconClass: any;
                                reference: string;
                                label:
                                    | string
                                    | number
                                    | boolean
                                    | ReactElement<any, string | JSXElementConstructor<any>>
                                    | Iterable<ReactNode>
                                    | ReactPortal
                                    | null
                                    | undefined;
                              },
                              index: Key | null | undefined
                          ) => {
                            // @ts-ignore
                            const SelectedIcon = Icons[
                            (item?.iconClass as IconKeys) || "AlignJustify"
                                ] as React.FC<LucideProps>;
                            return (
                                <SwiperSlide key={index} className="mx-4">
                                  <Link
                                      to={`/Events/${item?.reference}/${item?.label}`}
                                      className={`bg-primary py-2 flex flex-col text-sm items-center justify-center rounded-lg text-center font-semibold`}
                                  >
                                    <SelectedIcon
                                        className="my-2"
                                        width={32}
                                        height={32}
                                    />
                                    {item?.label}
                                  </Link>
                                </SwiperSlide>
                            );
                          }
                      )}
                  <SwiperSlide>
                    <div className='w-6 h-24'></div>
                  </SwiperSlide>
                </Swiper>
            )}
          </section>}

          {/* Prochains événements */}
          <section className="p-4">
            <h2 className="text-black text-lg mb-2">Prochains événements</h2>
            {renderEvents()}
          </section>
          <div className="flex justify-center my-2">
            <button
                className="self-center px-4 py-2 bg-third text-white rounded-lg"
                onClick={goToAllEvents}
            >
              <p className="">Tous les evénements</p>
            </button>
          </div>
        </div>
        <div className="">
        {/*<div className="fixed z-10 bottom-0 left-1/2 transform -translate-x-1/2">*/}
          {import.meta.env.MODE === "development" && (<p className='text-base text-center text-red-500'>Version de demo 0.0.1</p>)}
          <div className="flex h-8 text-third justify-center items-center gap-2">
            <p className='text-xs text-gray-700'>Powered by</p>
            <img className='size-12 object-contain' src='/Semoa.png' alt='Semoa'/>
          </div>
        </div>
      </div>
  );
};

export default App;
